import { IReward } from './IReward';

export abstract class Reward implements IReward {
    '_class': string;

    id?: number | null;

    validationErrors?: string[] | null = null;

    abstract getDescription(): string;

    abstract clone(): Reward;


    constructor(serverClass: string, id?: number | null) {
      /* eslint-disable no-underscore-dangle */
      this._class = serverClass;
      /* eslint-enable no-underscore-dangle */
      this.id = id;
    }
}

export default Reward;
